import React, { FC } from "react";

import { useTranslation } from "react-i18next";

import { StatusColorType } from "@/components/atoms/Status/styled";
import { Claim, Permissions } from "@/shared/domain";
import { useAuth, useNavigation } from "@/shared/hooks";

import { StyledClosedClaimCard } from "./styled";

export type ClosedClaimItemProps = {
    claim: Claim;
};

export const ClosedClaimItem: FC<ClosedClaimItemProps> = ({ claim }) => {
    const { t } = useTranslation();
    const { user } = useAuth();
    const { navToClaimDetail } = useNavigation();

    const canViewDetails = user.hasPermission(Permissions.ViewClaimsDetails, claim.policyholderId);

    const handleClaimDetails = () => {
        return canViewDetails && navToClaimDetail(claim);
    };

    const insurerFsma = claim.insurer?.fsma ? `(${claim.insurer?.fsma})` : "";

    return (
        <StyledClosedClaimCard
            onClickCard={handleClaimDetails}
            dataTestId={`closed_claim_item-card-${claim.id}`}
            clickable={canViewDetails}
            statusColor={StatusColorType.Info}
            statusText={t("Common.Closed")}
            companyName={`${claim.insurer.name}${insurerFsma}`}
            companyIcon={claim.insurer.logoUrl}
            date={claim.damageEventDate}
            title={claim.description}
            infos={[...(claim.victim ? [{ title: t("Common.Victim"), content: claim.victim }] : [])]}
            reference={`Ref ${claim.reference}`}
            text={claim.circumstance?.name}
        />
    );
};
